module.exports = __webpack_public_path__ + "fonts/journal.04dda88b.eot";